module.exports = __webpack_public_path__ + "static/founder-rc-6fded1424a3b8ed2fcc12f14550d32c6.png";